export default __webpack_public_path__ + "static/media/rent_boat.606dc9ac.png";